<template>
  <v-card class="mx-auto mt-2" outlined rounded>
    <v-list-tile>
      <v-list-tile-action>
        <v-icon color="orange">mdi-file</v-icon>
      </v-list-tile-action>

      <v-list-tile-content class="mt-2 mb-2">
        <v-list-tile-title>{{
          qualification.consumer_unit ||
          "Código Cliente: " + qualification.customer_number
        }}</v-list-tile-title>
        <v-list-tile-sub-title>{{
          getAddress(qualification.consumer_unit)
        }}</v-list-tile-sub-title>
        <v-list-tile-sub-title>{{ nome_titular }}</v-list-tile-sub-title>
        Solicitar ao membro envio da conta.
      </v-list-tile-content>

      <v-list-tile-action>
        <span class="font-weight-bold pl-2"> Conta não encontrada </span>
      </v-list-tile-action>
    </v-list-tile>
  </v-card>
</template>
<script>
export default {
  props: ["qualification", "installations_found", "nome_titular"],
  methods: {
    getAddress(id) {
      if (this.installations_found) {
        const uc = this.installations_found.find((installation) => {
          return installation.installation_number === id;
        });
        if (uc) return uc.address;
      } else {
        return null;
      }
    },
  },
};
</script>
